// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hide-goal-option[data-v-352fb49e]{margin-bottom:15px}.help-text[data-v-352fb49e]{margin-top:10px;color:#333}@media (min-width: 425px){.help-text[data-v-352fb49e]{font-size:16px}}@media (min-width: 425px){.hide-goal-switch[data-v-352fb49e]{font-size:16px !important}}\n", ""]);
// Exports
module.exports = exports;
